import React from 'react';
import { FadeIn } from './FadeIn';
import { TrustBadges } from './TrustBadges';
import { ChevronRightIcon, CheckCircle2Icon } from 'lucide-react';
export function Pricing() {
  return <section id="pricing" className="py-16 sm:py-24 px-4 bg-padel-surface relative" data-id="element-135">
      <div className="max-w-5xl mx-auto" data-id="element-136">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-stretch" data-id="element-137">
          {/* Base Tier */}
          <FadeIn delay={0.1} data-id="element-138">
            <div className="bg-padel-dark border border-padel-muted p-8 rounded-3xl h-full flex flex-col" data-id="element-139">
              <div className="mb-6" data-id="element-140">
                <span className="text-3xl mb-4 block" data-id="element-141">📘</span>
                <h3 className="text-2xl font-display font-bold text-white mb-2" data-id="element-142">
                  MÉTODO PRO-PÁDEL 360
                </h3>
                <p className="text-gray-400" data-id="element-143">
                  El sistema completo para transformar tus clases.
                </p>
              </div>

              <ul className="space-y-3 mb-8 flex-grow" data-id="element-144">
                <li className="flex items-center gap-3 text-gray-300" data-id="element-145">
                  <CheckCircle2Icon className="w-5 h-5 text-padel-lime shrink-0" data-id="element-146" />
                  <span data-id="element-147">6 Tomos del Método</span>
                </li>
                <li className="flex items-center gap-3 text-gray-300" data-id="element-148">
                  <CheckCircle2Icon className="w-5 h-5 text-padel-lime shrink-0" data-id="element-149" />
                  <span data-id="element-150">6 Bonos Exclusivos</span>
                </li>
                <li className="flex items-center gap-3 text-gray-300" data-id="element-151">
                  <CheckCircle2Icon className="w-5 h-5 text-padel-lime shrink-0" data-id="element-152" />
                  <span data-id="element-153">420+ páginas listas para usar</span>
                </li>
              </ul>

              <div className="mb-8" data-id="element-154">
                <div className="text-gray-500 line-through text-lg mb-1" data-id="element-155">
                  $89.000
                </div>
                <div className="text-4xl sm:text-5xl font-display font-black text-white" data-id="element-156">
                  $18.999{' '}
                  <span className="text-xl text-gray-400 font-sans font-normal" data-id="element-157">
                    ARS
                  </span>
                </div>
              </div>

              <a href="https://www.stockdigital.shop/checkouts/cn/hWNDJ5rPJCHXugS2TAClWlJy/es-ar?_r=AQAByFhbjIicHJUDM3enN1fk8usWMSP5mwoAhR8xUqrqxT8&cart_link_id=bGnZ6n2B&preview_theme_id=140123340859" target="_blank" rel="noopener noreferrer" className="w-full bg-white hover:bg-gray-100 text-padel-dark font-display font-bold text-lg px-6 py-4 rounded-xl flex items-center justify-center gap-2 transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-padel-dark" data-id="element-158">
                QUIERO MI PACK AHORA
                <ChevronRightIcon className="w-5 h-5" data-id="element-159" />
              </a>
            </div>
          </FadeIn>

          {/* Premium Tier */}
          <FadeIn delay={0.2} data-id="element-160">
            <div className="bg-gradient-to-b from-padel-surfaceHover to-padel-dark border-2 border-padel-lime p-8 rounded-3xl h-full flex flex-col relative shadow-[0_0_40px_rgba(197,255,61,0.15)] transform lg:-translate-y-4" data-id="element-161">
              <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-padel-lime text-padel-dark font-bold px-4 py-1 rounded-full text-sm uppercase tracking-wider" data-id="element-162">
                Recomendado
              </div>

              <div className="mb-6" data-id="element-163">
                <span className="text-3xl mb-4 block" data-id="element-164">🏆</span>
                <h3 className="text-2xl font-display font-bold text-white mb-2" data-id="element-165">
                  MÉTODO PRO-PÁDEL 360 <br data-id="element-166" />
                  <span className="text-padel-lime" data-id="element-167">+ SISTEMA PREMIUM</span>
                </h3>
                <p className="text-gray-400" data-id="element-168">
                  Para el profe que quiere cobrar lo que vale.
                </p>
              </div>

              <ul className="space-y-3 mb-8 flex-grow" data-id="element-169">
                <li className="flex items-center gap-3 text-white font-medium" data-id="element-170">
                  <CheckCircle2Icon className="w-5 h-5 text-padel-lime shrink-0" data-id="element-171" />
                  <span data-id="element-172">6 Tomos del Método</span>
                </li>
                <li className="flex items-center gap-3 text-white font-medium" data-id="element-173">
                  <CheckCircle2Icon className="w-5 h-5 text-padel-lime shrink-0" data-id="element-174" />
                  <span data-id="element-175">6 Bonos Exclusivos</span>
                </li>
                <li className="flex items-center gap-3 text-padel-lime font-bold" data-id="element-176">
                  <CheckCircle2Icon className="w-5 h-5 text-padel-lime shrink-0" data-id="element-177" />
                  <span data-id="element-178">+ 4 Módulos Premium</span>
                </li>
              </ul>

              <div className="mb-8" data-id="element-179">
                <div className="text-gray-500 line-through text-lg mb-1" data-id="element-180">
                  $149.000
                </div>
                <div className="text-4xl sm:text-5xl font-display font-black text-padel-lime drop-shadow-[0_0_15px_rgba(197,255,61,0.3)]" data-id="element-181">
                  $28.999{' '}
                  <span className="text-xl text-gray-400 font-sans font-normal" data-id="element-182">
                    ARS
                  </span>
                </div>
              </div>

              <a href="https://www.stockdigital.shop/checkouts/cn/hWNDJ5h0SEOe27ZfBd1HsOXa/es-ar?_r=AQABRaW3usbMblk_hIhTYNxvIAbbjQAkJrmNbdM7Wg0z3ls&cart_link_id=NdVbq3jh&preview_theme_id=140123340859" target="_blank" rel="noopener noreferrer" className="w-full bg-padel-lime hover:bg-padel-limeHover text-padel-dark font-display font-black text-xl px-6 py-5 rounded-xl flex items-center justify-center gap-2 transition-all transform hover:scale-[1.02] active:scale-[0.98] shadow-[0_0_20px_rgba(197,255,61,0.2)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-padel-lime focus-visible:ring-offset-2 focus-visible:ring-offset-padel-dark" data-id="element-183">
                QUIERO MI PACK AHORA
                <ChevronRightIcon className="w-6 h-6" strokeWidth={3} data-id="element-184" />
              </a>
            </div>
          </FadeIn>
        </div>

        <FadeIn delay={0.4} data-id="element-185">
          <div className="mt-12" data-id="element-186">
            <TrustBadges data-id="element-187" />
          </div>
        </FadeIn>
      </div>
    </section>;
}